import { normalizarPaisDomicilio } from "../constants/paisesDomicilio";

/** Claves persistidas en `contactos` y en propietarios_ficha / contactos_asociados_ficha. */
export const DOMICILIO_CONTACTO_KEYS = [
  "direccion",
  "numero",
  "bloque",
  "escalera",
  "piso",
  "puerta",
  "codigo_postal",
  "poblacion",
  "provincia",
  "pais",
];

export function domicilioContactoVacio() {
  return {
    direccion: "",
    numero: "",
    bloque: "",
    escalera: "",
    piso: "",
    puerta: "",
    codigo_postal: "",
    poblacion: "",
    provincia: "",
    pais: "ES",
  };
}

function pickStr(...cands) {
  for (const c of cands) {
    const s = c == null ? "" : String(c).trim();
    if (s) return s;
  }
  return "";
}

/** Hidrata desde ficha APP (`numero`/`domicilio_*`) o fila `contactos`. */
export function hidratarDomicilioContacto(src = {}) {
  const s = src && typeof src === "object" ? src : {};
  // Priorizar domicilio_base (calle limpia APP); `direccion` a veces venía compuesto
  return {
    direccion: pickStr(s.domicilio_base, s.direccion, s.domicilio),
    numero: pickStr(s.numero, s.domicilio_numero),
    bloque: pickStr(s.bloque, s.domicilio_bloque),
    escalera: pickStr(s.escalera, s.domicilio_escalera),
    piso: pickStr(s.piso, s.domicilio_piso),
    puerta: pickStr(s.puerta, s.domicilio_puerta),
    codigo_postal: pickStr(s.codigo_postal, s.cp, s.domicilio_cp),
    poblacion: pickStr(s.poblacion, s.domicilio_poblacion),
    provincia: pickStr(s.provincia, s.domicilio_provincia),
    pais: normalizarPaisDomicilio(s.pais || s.domicilio_pais || "ES"),
  };
}

/** Completa huecos de `base` con `extra` (no pisa un valor ya relleno). */
export function rellenarDomicilioSiFalta(base = {}, extra = {}) {
  const a = hidratarDomicilioContacto(base);
  const b = hidratarDomicilioContacto(extra);
  const out = { ...a };
  for (const k of DOMICILIO_CONTACTO_KEYS) {
    if (k === "pais") {
      if ((!out.pais || out.pais === "ES") && b.pais && b.pais !== "ES") out.pais = b.pais;
      continue;
    }
    if (!out[k] && b[k]) out[k] = b[k];
  }
  return out;
}

function trimOrNull(v) {
  const s = String(v ?? "").trim();
  return s || null;
}

/** Payload PATCH/POST `/contactos`. */
export function payloadDomicilioContacto(form = {}) {
  return {
    direccion: trimOrNull(form.direccion),
    numero: trimOrNull(form.numero),
    bloque: trimOrNull(form.bloque),
    escalera: trimOrNull(form.escalera),
    piso: trimOrNull(form.piso),
    puerta: trimOrNull(form.puerta),
    codigo_postal: trimOrNull(form.codigo_postal),
    poblacion: trimOrNull(form.poblacion),
    provincia: trimOrNull(form.provincia),
    pais: trimOrNull(form.pais) || "ES",
  };
}

/** Campos que van a la fila de ficha (strings, sin sustituir el resto del objeto). */
export function fichaDomicilioDesdeForm(form = {}) {
  return {
    direccion: String(form.direccion || "").trim(),
    domicilio_base: String(form.direccion || "").trim(),
    numero: String(form.numero || "").trim(),
    bloque: String(form.bloque || "").trim(),
    escalera: String(form.escalera || "").trim(),
    piso: String(form.piso || "").trim(),
    puerta: String(form.puerta || "").trim(),
    codigo_postal: String(form.codigo_postal || "").trim(),
    poblacion: String(form.poblacion || "").trim(),
    provincia: String(form.provincia || "").trim(),
    pais: normalizarPaisDomicilio(form.pais || "ES"),
  };
}

/**
 * Extras del titular (APP lee `domicilio_numero`, etc.).
 * Solo escribe una clave si el formulario la trae definida.
 */
export function extrasDomicilioTitularDesdePersona(persona, extras = {}) {
  if (!persona || typeof persona !== "object") return extras;
  const next = { ...extras };
  const setIfDef = (extraKey, val) => {
    if (val === undefined) return;
    next[extraKey] = val == null ? "" : String(val).trim();
  };
  setIfDef("domicilio_base", persona.direccion ?? persona.domicilio_base);
  setIfDef("domicilio_numero", persona.numero ?? persona.domicilio_numero);
  setIfDef("domicilio_bloque", persona.bloque ?? persona.domicilio_bloque);
  setIfDef("domicilio_escalera", persona.escalera ?? persona.domicilio_escalera);
  setIfDef("domicilio_piso", persona.piso ?? persona.domicilio_piso);
  setIfDef("domicilio_puerta", persona.puerta ?? persona.domicilio_puerta);
  setIfDef("domicilio_cp", persona.codigo_postal ?? persona.cp ?? persona.domicilio_cp);
  setIfDef("domicilio_poblacion", persona.poblacion ?? persona.domicilio_poblacion);
  setIfDef("domicilio_provincia", persona.provincia ?? persona.domicilio_provincia);
  setIfDef("domicilio_pais", persona.pais ?? persona.domicilio_pais);
  return next;
}
